<template>
     <div class="spSelectModal view-userCoupon" :class="{ active: isShow}">
        <div class="spSelectModal-bg" @click="onClose"></div>
        <div class="spSelectModal-container">
            <div class="spSelectModal-con">
                <div class="spSelect-item">
                    <div class="spSelect-item-title">选择生日乘客</div>
                    <div class="spSelect-item-content">
                        <div class="spSelect-item-option" v-for="(guest, i) in specialBookingGuests" :key="('guest_'+i)"
                        :class="{ active: isGuestSelectedSp(guest)}"
                        @click="onGuestSelected(guest)">
                            {{getGuestName(guest, i)}}
                        </div>
                    </div>
                 </div>
                 <div class="spSelect-item spSelect-date">
                    <div class="spSelect-item-title">选择享用生日蛋糕日期</div>
                    <div class="spSelect-item-content">
                        <div class="spSelect-item-option" v-for="(date, i) in mealDates" :key="('mealInfo_'+i)"
                        :class="{ active: selectedDate == date}"
                        @click="onDateClick(date)">
                            <div class="date">
                                {{getDate(date)}}
                            </div>
                            <div class="day">
                                {{getDay(i)}}
                            </div>
                        </div>
                    </div>
                 </div>
<!--                 <div class="spSelect-item spSelect-timeslot">-->
<!--                    <div class="spSelect-item-title">选择用餐时间</div>-->
<!--                    <div class="spSelect-item-content">-->
<!--                        <div class="spSelect-item-option" v-for="(timeslot, i) in mealTimeslots" :key="('timeslot_'+i)"-->
<!--                        :class="{ active: selectedTimeslot == timeslot.mealTimeType, disable: isTimeslotDisable(timeslot)}"-->
<!--                        @click="onTimeslotClick(timeslot)">-->
<!--                            {{mealPlace.mealPlace}}·{{timeslot.mealTime}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                 </div>-->
                <div class="birthday-con">
                  <div class="birthday-title">
                    请您在所选日期按照<span style="color: #FF0000;">指定晚餐时间</span>前往<span style="color: #FF0000;">主餐厅</span>享用蛋糕。（指定的晚餐时间可参考在线值船时系统显示，并以船卡显示为准）
                  </div>
                  <div class="birthday-text">
                    开航前7天及以内，不再接受任何修改和取消，已收取的费用将不予退回。
                  </div>
                </div>
            </div>
            <div class="spSelect-message" :class="{ hidden: (!errMsg || errMsg.trim() == '')}">
                {{errMsg}}
            </div>
            <div class="spSelect-buttons">
                <div class="spSelect-button closeBtn" @click="onRemoveAllSelected">暂不选择</div>
                <div class="spSelect-button confirmBtn" @click="submitSp"
                :class="{ active: checkSubmtData().length == 0}">确认</div>
            </div>
            <div class="spSelectModal-closed js-closedBtn" @click="onClose">
                <img src="https://resource.rcclchina.com.cn/birthday/close-btn.png"/>
            </div>
        </div>
    </div>
</template>

<script>
import { numberToChinese } from '@/utilities/tools'
import { SpecialBookingType } from '@/utilities/specialBookingHelper'
import _ from 'lodash'
import api from '@/api'
export default {
    name: "GuestInfoSpecialBookingSelect",
    props: {
        isShow: {
            type: Boolean
        },
        guests: {
            type: Array,
            default() {
                return []
            }
        },
        couponCode: {
            type: String
        },
        sessionToken: {
            type: String
        },
        specialBooking: {
            type: Object,
            default() {
                return {}
            }
        },
        mealInfoViews: {
            type: Array,
            default () {
                return []
            }
        },
        onConfirmSpecialBooking:{
            type: Function
        },
        onClose: {
            type: Function
        }
    },
    data () {
        return {
            specialBookingGuests: [],
            selectedDate: '',
            selectedTimeslot: 0,
            errMsg: '测试测试测试测试'
        }
    },
    mounted () {
        this.initSpecialBookingGuests()
    },
    methods: {
        initSpecialBookingGuests () {
            this.selectedDate = ''
            this.selectedTimeslot = 0
            this.specialBookingGuests = []
            if (this.guests && this.guests.length > 0) {
                this.guests.forEach(guest=> {
                    this.specialBookingGuests.push({
                        lastName: guest.lastName,
                        firstName: guest.firstName,
                        pyLastName: guest.pyLastName,
                        pyFirstName: guest.pyFirstName,
                        birthDate: guest.birthDate,
                        specialBookingOrder: guest.specialBookingOrder
                    })
                    if (this.isGuestSelectedSp(guest)) {
                        this.selectedDate = guest.specialBookingOrder.specialBookingDate
                        this.selectedTimeslot = guest.specialBookingOrder.specialBookingTimeslot
                    }
                })
            }
            this.errMsg = ''
        },
        // 最多选1个
        isGuestDisable () {
            return this.selectedGuests.length >= 1
        },
        getGuestName(guest, i) {
            let name = (guest.lastName || '') + (guest.firstName || '')
            if (!name || name.trim().length == 0) {
                name = `${guest.pyLastName} ${guest.pyFirstName}`
                if (!name || name.trim().length == 0) {
                    name = `乘客${i+1}`
                }
            }
            return name
        },
        isGuestSelectedSp(guest) {
            return guest.specialBookingOrder &&
            guest.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType
        },
        onGuestSelected(guest) {
            if (this.isGuestSelectedSp(guest)) {
                guest.specialBookingOrder = null
            } else {
                // 最多选1个人，如果选第二个人，第一个人反选
                if (this.isGuestDisable()) {
                    let selectedGuests = _.orderBy(this.selectedGuests, 'specialBookingOrder.selectTime')
                    if (selectedGuests && selectedGuests.length > 0) {
                        selectedGuests[0].specialBookingOrder = null
                    }
                }
                guest.specialBookingOrder = {
                    specialBookingType: this.specialBooking.specialBookingType,
                    specialBookingPlace: this.mealPlace.mealPlaceType, // 主餐厅默认写死
                    specialBookingTimeslot: this.selectedTimeslot,
                    specialBookingCodes: this.specialBooking.optionCodes,
                    specialBookingDate: this.selectedDate,
                    selectTime: (Date.now())
                }
            }
        },
        getDate (date) {
            if (date && date.length == 10) {
                return date.substr(5, 5)
            }
            return date;
        },
        getDay (i) {
            return `第${numberToChinese(i+2)}天`
        },
        onDateClick (date) {
            if (this.selectedDate == date) {
                this.selectedDate = ''
            } else {
                this.selectedDate = date
                // 第一天不能选午餐。如果之前选择了午餐，日期又选了第一天，需要把午餐反选
                if (this.selectedTimeslot == 1) {
                    let index = this.mealDates.indexOf(this.selectedDate)
                    if (index == 0) {
                        this.selectedTimeslot = 0
                    }
                }
            }
        },
        // 第一天不能选午餐
        isTimeslotDisable (timeslot) {
            if (timeslot.mealTimeType == 2) return false
            if (this.selectedDate && this.selectedDate.length > 0) {
                let index = this.mealDates.indexOf(this.selectedDate)
                if (index == 0) return true
            }
            return false
        },
        onTimeslotClick (timeslot) {
            if (this.selectedTimeslot == timeslot.mealTimeType) {
                this.selectedTimeslot = 0
            } else {
                if (this.isTimeslotDisable(timeslot)) return
                this.selectedTimeslot = timeslot.mealTimeType
            }
        },
        checkSubmtData () {
            let errors = []
            let guestCount = this.selectedGuests.length
            if (guestCount == 0) {
                errors.push('请选择乘客！')
            }
            else if (guestCount > 2) {
                errors.push('最多可选择2位乘客！')
            }
            if (!this.selectedDate || this.selectedDate.length == 0) {
                errors.push('请选择享用蛋糕日期！')
            }
            // if (this.selectedTimeslot == 0) {
            //     errors.push('请选择享用蛋糕时间！')
            // }
            return errors
        },
        submitSp() {
            const errors = this.checkSubmtData()
            if (errors.length > 0) {
                this.errMsg = errors[0]
                return
            }
            this.errMsg = ''
            let submitGuests = []
            this.specialBookingGuests.forEach(guest=> {
                if (this.isGuestSelectedSp(guest)) {
                    guest.specialBookingOrder.specialBookingPlace = this.mealPlace.mealPlaceType, // 主餐厅默认写死
                    guest.specialBookingOrder.specialBookingTimeslot = this.selectedTimeslot,
                    guest.specialBookingOrder.specialBookingCodes = this.specialBooking.optionCodes,
                    guest.specialBookingOrder.specialBookingDate = this.selectedDate
                    submitGuests.push(guest)
                }
            })
            let guests = [...this.guests]
            guests.forEach(guest=> {
                let submitGuest = submitGuests.find(r=>r.pyLastName==guest.pyLastName
                && r.pyFirstName==guest.pyFirstName
                && r.birthDate==guest.birthDate)
                if (submitGuest) {
                    guest.specialBookingOrder = submitGuest.specialBookingOrder
                } else {
                    guest.specialBookingOrder = null
                }
            })
            this.onSpecialBookingSubmit(guests)
        },
        async onSpecialBookingSubmit(guests) {

            let requestData = {
                bookingKey: this.bookingKey,
                token: this.sessionToken,
                guests: {
                    guestPersons: guests
                },
                couponCode: this.couponCode
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.updateSpecialBookingHPApi(requestData)
            this.$loading.hide()
            if (!success) {
                this.errMsg = errMsg
                return
            }
            if (data && data.model && data.model.bookings) {
                let order = this.order
                order.bookings = data.model.bookings
                // 调用父组件方法
                this.onConfirmSpecialBooking(data.model.bookings)
                this.$store.commit('SET_BOOKING_FUNNEL_ORDER', order)
            }
            this.onClose()
        },
        async onRemoveAllSelected() {
            let guests = [...this.guests]
            guests.forEach(guest=> {
                guest.specialBookingOrder = null
            })
            await this.onSpecialBookingSubmit(guests)
        }
    },
    computed: {
        order () {
            return this.$store.state.booking.order
        },
        bookingKey () {
            return this.$store.state.booking.bookingKey
        },
        mealDates () {
            let mealDates = []
            this.mealInfoViews.map(r=>r.mealDate).forEach(date => {
                if (!mealDates.some(r=>r == date)) {
                    mealDates.push(date)
                }
            })
            return mealDates
        },
        mealTimeslots () {
            let mealTimeslots = []
            this.mealInfoViews.forEach(mealInfo => {
                if (!mealTimeslots.some(r=> r.mealTime == mealInfo.mealTime && r.mealTimeType == mealInfo.mealTimeType)) {
                    mealTimeslots.push({
                        mealTime: mealInfo.mealTime,
                        mealTimeType: mealInfo.mealTimeType
                    })
                }
            })
            return _.orderBy(mealTimeslots, 'mealTimeType')
        },
        mealPlace () {
            if (this.mealInfoViews.length > 0) {
                return {
                    mealPlace: this.mealInfoViews[0].mealPlace,
                    mealPlaceType: this.mealInfoViews[0].mealPlaceType
                }
            } else {
                return {
                    mealPlace: '',
                    mealPlaceType: 0
                }
            }
        },
        selectedGuests () {
            return this.specialBookingGuests
                .filter(r=>r.specialBookingOrder
                && r.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType)
        },
        isBirthday () {
            return this.specialBooking.specialBookingType == SpecialBookingType.Birthday
        }
    },
    watch: {
        isShow (newOne) {
            if (newOne) {
                // 新弹出选择框后，重新从guest中查看特别礼遇选择情况
                this.initSpecialBookingGuests()
            }
        },
        specialBookingType (newOne, oldOne) {
            // 如果切换特别礼遇，之前选择的内容清空
            if (newOne && oldOne && newOne.specialBookingType > 0 && oldOne.specialBookingType > 0
            && newOne.specialBookingType != oldOne.specialBookingType) {
                this.selectedDate = ''
                this.selectedTimeslot = ''
            }
        }
    }
}
</script>


<style lang="less" scoped>
.spSelectModal {
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: none;
    .spSelectModal-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .spSelectModal-container {
        background-color: #fff;
        border-top: 5px solid #FCC300;
        position: absolute;
        bottom: 0;
        width: 100%;
        .spSelectModal-title {
            padding: 10px 10px 10px 15px;
            border-bottom: solid 1px rgba(229, 229, 229, 0.6);
            .title-text {
                font-size: 14px;
                color: #000;
            }
            .title-subtitle {
                margin-top: 9px;
                font-size: 10px;
                color: #000000;
                span {
                    color: #FF5055;
                }
            }
        }
        .spSelectModal-con {
            max-height: 400px;
            overflow-y: scroll;
            padding: 5px 0px 10px 15px;
            .spSelect-item {
                margin-top: 15px;
                .spSelect-item-title {
                    font-size: 14px;
                    color: #000;
                }
                .spSelect-item-content {
                    margin-top: 20px;
                    margin-left: 5px;
                    .spSelect-item-option {
                        width: 80px;
                        height: 30px;
                        line-height: 30px;
                        margin-right: 5px;
                        background: #F6F6F6;
                        border-radius: 4px;
                        font-size: 14px;
                        text-align: center;
                        display: inline-block;
                        vertical-align: middle;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        padding: 0px 5px;
                        margin-bottom: 5px;
                        &.disable {
                            background: #F6F6F6;
                            color: #C0C0C0;
                        }
                        &.active {
                            background: #FFD74D;
                            color: #000;
                        }
                    }
                }
                &.spSelect-date {
                    .spSelect-item-option {
                        height: 40px;
                        line-height: initial;
                        padding-top: 6px;
                        .day {
                            font-size: 10px;
                        }
                    }
                }
                &.spSelect-timeslot {
                    .spSelect-item-option {
                        width: 165px;
                    }
                }
            }
          .birthday-con{
            font-size: 10px;
            padding: 12px 27px 0 0;
            .birthday-text{
              color: #9F9F9F;
            }
          }

        }
        .spSelect-message {
            height: 24px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #FF5055;
            font-size: 11px;
            background: #EEEEEE;
            text-align: center;
            &.hidden {
                background: white;
                display: block;
            }
        }
        .spSelect-buttons {
            .spSelect-button {
                display: inline-block;
                margin: 0px;
                width: 50%;
                height: 51px;
                line-height: 51px;
                background: #F6F6F6;
                font-size: 18px;
                color: #000;
                text-align: center;
                &.confirmBtn {
                    background: #E3E3E3;
                }
                &.confirmBtn.active {
                    background: #FFD956;
                }
            }
        }
        .spSelectModal-closed {
            width: 29px;
            position: absolute;
            top: -4px;
            right: -4px;
            img {
                width: 100%;
            }
        }


    }
}

.spSelectModal.active {
    display: block;
}
</style>

